import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';
import { Router } from '@angular/router';
import { Observable, Subscription, firstValueFrom } from 'rxjs';
import { MEETING_TYPE_LIST_VIEW_PAGE_TOKEN } from '../../data-providers/providers';

export interface BookingUrlDialogData {
  bookingUrl: string;
  meetingId: string;
}

@Component({
  selector: 'meeting-scheduler-booking-url-dialog',
  templateUrl: './booking-url-dialog.component.html',
  styleUrls: ['./booking-url-dialog.component.scss'],
  standalone: false,
})
export class BookingUrlDialogComponent implements OnInit, OnDestroy {
  copied = false;
  private subscription: Subscription | null = null;

  constructor(
    private readonly ref: MatDialogRef<BookingUrlDialogComponent>,
    @Inject(MAT_DIALOG_DATA) readonly data: BookingUrlDialogData,
    private readonly clipboard: Clipboard,
    private readonly router: Router,
    @Inject(MEETING_TYPE_LIST_VIEW_PAGE_TOKEN) private readonly meetingTypeLink$: Observable<string>,
  ) {}

  ngOnInit(): void {
    this.subscription = this.ref.beforeClosed().subscribe(() => {
      this.navigateBack();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onClose(): void {
    this.ref.close();
  }

  private async navigateBack(): Promise<void> {
    // Navigate to meeting-type page using the injected link
    try {
      const meetingTypeUrl = await firstValueFrom(this.meetingTypeLink$);
      if (meetingTypeUrl) {
        await this.router.navigate([meetingTypeUrl]);
      } else {
        // Fallback if no URL is provided
        window.history.back();
      }
    } catch (error) {
      // Fallback to browser history if navigation fails
      window.history.back();
    }
  }

  onCopyUrl(): void {
    const success = this.clipboard.copy(this.data.bookingUrl);
    if (success) {
      this.copied = true;
      // Reset the copied state after 2 seconds
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    }
  }
}
